import Vue from 'vue';
import ToastComponent from '../components/msgBox/toast.vue' // 确保路径正确

const ToastConstructor = Vue.extend(ToastComponent);

let instance;

const Toast = {
    install(Vue) {
        Vue.prototype.$toast = (message, duration = 2000) => {
            if (!instance) {
                instance = new ToastConstructor();
                instance.$mount(document.createElement('div'));
                document.body.appendChild(instance.$el);
            }
            instance.show(message, duration);
        };
    }
};

export default Toast;


// WEBPACK FOOTER //
// ./src/utils/toast.js